import { render, staticRenderFns } from "./Index.html?vue&type=template&id=6394fa33&external"
import script from "./StudentScheduleV2.vue?vue&type=script&lang=js"
export * from "./StudentScheduleV2.vue?vue&type=script&lang=js"
import style0 from "./StudentScheduleV2.vue?vue&type=style&index=0&id=6394fa33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports